import * as axios from '../../axios-extended'
import * as t from 'io-ts'
import { pipe } from 'fp-ts/lib/function'
import { taskEither } from 'fp-ts'

const apiUrl = '/prosperbill/api'

const Commitment = t.type(
  {
    type: t.literal('commitment'),
    protocolVersion: t.literal('dcn1.0'),
    dcnNymID: t.string,
    userNymID: t.string,
    terms: t.type({ hash: t.string, url: t.string }, 'CommitmentTerms'),
    signatures: t.record(
      t.string,
      t.type(
        { clauses: t.array(t.string), signature: t.string },
        'SignatureInfo'
      )
    ),
    balance: t.record(t.string, t.number),
  },
  'Commitment'
)

export const getBalance = (
  organization: string,
  cancelToken?: axios.CancelToken
) =>
  pipe(
    axios.get(`${apiUrl}/wallets/${organization}`, {
      cancelToken,
      decoder: Commitment,
    }),
    taskEither.map(({ balance, userNymID }) => ({ balance, userNymID }))
  )
